import { useQuery } from '@apollo/react-hooks';
import { useEffect, useMemo, useState } from 'react';
import { RETRIEVE_BEST_OFFER } from '../../graphql/promotion';
export const BEST_OFFER_TIMEOUT_MS = 5000;

const useRetrieveBestOffer = ({
  productCode,
  timeoutMs = BEST_OFFER_TIMEOUT_MS,
  ...options
} = {}) => {
  var _retrieve$data;

  const variables = useMemo(() => ({ ...(productCode && {
      product_code: productCode
    })
  }), [productCode]);
  const skip = !!options.skip;
  const retrieve = useQuery(RETRIEVE_BEST_OFFER, { ...options,
    variables,
    skip
  });
  const [timedOut, setTimedOut] = useState(false);
  const [everSettled, setEverSettled] = useState(skip);
  const isWaiting = !skip && retrieve.loading;
  useEffect(() => {
    if (!isWaiting) {
      setEverSettled(true);
      return undefined;
    }

    const timer = setTimeout(() => setTimedOut(true), timeoutMs);
    return () => clearTimeout(timer);
  }, [isWaiting, timeoutMs]);
  const bestOffer = retrieve.error || timedOut ? undefined : (_retrieve$data = retrieve.data) === null || _retrieve$data === void 0 ? void 0 : _retrieve$data.bestOffer;
  return [bestOffer, { ...retrieve,
    timedOut,
    settled: everSettled || timedOut
  }];
};

export default useRetrieveBestOffer;